import React, { useState, useEffect } from 'react';
import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';
import AssetViewer from './assetViewer';

const Asset3DModal = ({ linkedAssetList }) => {

  const [theeDAssetFile, setTheeDAssetFile] = useState(null);
  const [assetList, setAssetList] = useState([]);

  useEffect(() => {
    if(linkedAssetList.length >0){
      setAssetList(linkedAssetList);
      setTheeDAssetFile(linkedAssetList[0].url)
    }
  }, [linkedAssetList]);

  return (
    <div className='container'>
      <div className='module-frame'>
        <Tab.Container defaultActiveKey="sop0">

          <div className='playscreen'>
            <div className='frame-parent' style={{ backgroundColor: "#ffffff", boxShadow: "none" }}>
              <div className="globe">
                {theeDAssetFile && <AssetViewer theeDAssetFile={theeDAssetFile} /> }
              </div>
            </div>
          </div>

          <div className='module-info'>
            <div className='video-list'>
              <div className='video-list-scroll forsop'>
                <Nav variant="pills" className="flex-column">
                  <Nav.Item>
                    <Nav.Link>

                      {assetList.map((item)=>(
                        <div className='sop-list-item' key={item.uuid} onClick={()=>setTheeDAssetFile(item.url)} >
                           <span className='pdfsop'>
                            <img src={item.thumbnail} alt={item.name} />
                          </span>
                          <p className='sopname'> {item.name} </p>
                        </div>
                      ))}

                    </Nav.Link>
                  </Nav.Item>
                </Nav>
              </div>
            </div>
          </div>

        </Tab.Container>
      </div>

    </div>
  )
}

export default Asset3DModal;
